import React from 'react';
import { Box } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

// import { Container } from './styles';
import useStyles from './styles';

const BoxMessage = () => {
  const classes = useStyles();

  return (
    <Box className={`${classes.container} is-expanded`}>
      <Skeleton
        className="msg-collapse-icon"
        variant="circle"
        width={36}
        height={36}
      />
      <Box className="msg-collapse-text-container">
        <Skeleton
          className="msg-collapse-text-title"
          variant="text"
          width="25%"
        />
        <Skeleton
          className="msg-collapse-text-message"
          variant="text"
          width="50%"
        />
        <Skeleton
          className="msg-collapse-text-message"
          variant="text"
          width="100%"
        />
      </Box>
    </Box>
  );
};

export default BoxMessage;
